export class SignalBufferLineModeProvider {
  constructor(signalBuffer) {
    this.signalBuffer = signalBuffer;
  }

  createPointBuffer(graphicDataBufferLength, pointCount) {
    const graphicBufferLength = graphicDataBufferLength;
    this.signalBuffer.graphicBufferLength = graphicBufferLength;
    this.signalBuffer.pixelsPerPoint = this.signalBuffer.settings.plotSize.width / Math.floor(pointCount / this.signalBuffer.settings.scaleX);
      
    (this.signalBuffer.graphicPointsBuffer = []).length = graphicBufferLength;
    for (let pointIndex = 0; pointIndex < graphicBufferLength; ++pointIndex) {
      this.signalBuffer.graphicPointsBuffer[pointIndex] = 0;
    }
    this.signalBuffer.pointBuffer = new Float32Array(this.signalBuffer.graphicDataBufferLength * 4);

    const plotWidth = this.signalBuffer.settings.plotSize.width;
    const pixelsPerPoint = this.signalBuffer.pixelsPerPoint;
    let x = 0;
    let pointXIndex = 0;
    for (let pointIndex = 0; pointIndex < graphicBufferLength; ++pointIndex, pointXIndex += 4) {
      this.signalBuffer.pointBuffer[pointXIndex] = x;
      x += pixelsPerPoint;
      if (x > plotWidth) {
        x = plotWidth - 1;
      }
      this.signalBuffer.pointBuffer[pointXIndex + 2] = x;
    }
  }

  updatePixelsPointsValues() {
    if (this.signalBuffer.actualGraphicDataBufferLength == 0) {
      return;
    }

    let data = this.signalBuffer.getData(0);
    if (data != null) {
      data = this.signalBuffer.convertValueToPixels(data);
      this.signalBuffer.graphicPointsBuffer[0] = data;
    }
    // create line for first point
    for (let i = 1, prevPointIndex = 0; i < this.signalBuffer.actualGraphicDataBufferLength; ++i, prevPointIndex += 4) {
      data = this.signalBuffer.getData(i);
      if (data != null) {
        data = this.signalBuffer.convertValueToPixels(data);
        this.signalBuffer.graphicPointsBuffer[i] = data;
        this.signalBuffer.pointBuffer[prevPointIndex + 1] = this.signalBuffer.graphicPointsBuffer[i - 1]; // prev
        this.signalBuffer.pointBuffer[prevPointIndex + 3] = this.signalBuffer.graphicPointsBuffer[i]; // curr
      }
    }
  }

  putData(data) {
    this.signalBuffer.graphicDataIndex++;
    if (this.signalBuffer.graphicDataIndex == this.signalBuffer.graphicDataBufferLength) {
      this.signalBuffer.graphicDataIndex = 0;
      this.signalBuffer.sectorIndex = 0;
    }
    let newData = data == null ? null : this.signalBuffer.convertValueToPixels(data);
    this.signalBuffer.graphicPointsBuffer[this.signalBuffer.graphicDataIndex] = newData;

    if (this.signalBuffer.graphicIndex < 0) {
      this.signalBuffer.pointBuffer[1] = newData;
      this.signalBuffer.isLastNull = newData == null;
      if (newData != null) {
        this.signalBuffer.notNullSectors = [
          {
            begin: 0,
            end: 0
          }
        ];
      }
    } else {
      if (this.signalBuffer.graphicDataIndex == 0) {
        if (newData == null) {
          this.signalBuffer.pointBuffer[1] = 0;
          this.signalBuffer.pointBuffer[3] = 0;
        } else {
          this.signalBuffer.pointBuffer[1] = this.signalBuffer.pointBuffer[(this.signalBuffer.graphicDataBufferLength - 1) * 4 + 3];
          this.signalBuffer.pointBuffer[3] = newData;
          this.signalBuffer._pushIndexToNotNullSectors(0);
        }
      } else {
        if (newData == null) {
          this.signalBuffer.pointBuffer[this.signalBuffer.graphicDataIndex * 4 + 1] = 0; // prev
          this.signalBuffer.pointBuffer[this.signalBuffer.graphicDataIndex * 4 + 3] = 0; // curr
        } else {
          this.signalBuffer._pushIndexToNotNullSectors(this.signalBuffer.graphicDataIndex);
          this.signalBuffer.pointBuffer[this.signalBuffer.graphicDataIndex * 4 + 1] = this.signalBuffer.pointBuffer[(this.signalBuffer.graphicDataIndex - 1) * 4 + 3]; // prev
          this.signalBuffer.pointBuffer[this.signalBuffer.graphicDataIndex * 4 + 3] = newData; // curr
        }
      }
      this.signalBuffer.isLastNull = newData == null;
    }
    this.signalBuffer.sectorIndex = this.signalBuffer.graphicDataIndex;
    this.signalBuffer.graphicIndex = this.signalBuffer.graphicDataIndex;
  }
}